import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import 'dayjs/locale/es'

dayjs.locale('es')

// Registers dayJs plugins
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

// CONSTANTES QUE NECESITA NAVARRA (Y EL COMPILADOR)
export const FMT = {
  time: 'HH:mm',
  onlyDate: 'DD/MM/YYYY',
  onlyDateDash: 'YYYY-MM-DD',
  date: 'DD/MM/YYYY HH:mm',
  dateDash: 'YYYY-MM-DD HH:mm',
  display: 'DD/MM/YYYY HH:mm:ss',
  dateFetch: 'YYYY-MM-DD HH:mm:ss.SSS',
  simulation: 'YYYY_MM_DD_HH_mm',
  simViento: 'YYYY-MM-DDTHH:00:00.000Z',
  simulationWithWind: 'MM-DD-YYYY_HH00'
}
export const DayjsUnit = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year',
  Hour: 'hour',
  Minute: 'minute',
  Second: 'second',
  Millisecond: 'millisecond'
}

const format1 = 'DD/MM/YYYY HH:mm'
const timeFormat = 'HH:mm'

const DateService = {

  parseDate (dateString, format = null) {
    if (format) {
      return dayjs(dateString, format, true)
    } else {
      let pattern = /\d{1,2}[/]\d{1,2}[/]\d{4} (\d\d):[0-5]\d$/
      let hasFormat = pattern.test(dateString)
      if (hasFormat) {
        return dayjs(dateString, format1, true)
      } else {
        return dayjs(dateString, true)
      }
    }
  },

  formatDate (date, format = 'YYYY-MM-DD') {
    if (!date) return ''
    if (date === '') return date
    if (typeof date === 'string') {
      date = this.parseDate(date)
    }
    return date.format(format)
  },

  getCurrentDateDB () {
    return dayjs().toISOString()
  },

  currentDate () {
    return dayjs().format(format1)
  },

  parseTime (timeString) {
    return dayjs(timeString, timeFormat, true)
  },

  formatTime (time) {
    if (!time) return ''
    if (time === '') return time
    if (typeof time === 'string') {
      time = this.parseTime(time)
    }
    return time.format(timeFormat)
  },

  currentTime () {
    return dayjs().format(timeFormat)
  },

  add (date, value, field) {
    return this.parseDate(date).add(value, field)
  },

  subtract (date, value, field) {
    return this.parseDate(date).subtract(value, field)
  },

  now () {
    return dayjs()
  },

  isValid (date) {
    return this.parseDate(date).isValid()
  },

  getCurrentDayJs () {
    return dayjs()
  },

  toDayjs (input, format = format1) {
    if (!input) return dayjs(NaN)
    if (input instanceof Date) return dayjs(input)
    if (typeof input === 'number') return dayjs(input)

    const isIsoUtc = /T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(input)
    if (isIsoUtc) {
      return dayjs.utc(input).local()
    } else {
      return dayjs(input, format, true)
    }
  },

  toString (input, format = FMT.display) {
    const d = dayjs.isDayjs(input) ? input : this.toDayjs(input)
    return d.format(format)
  },

  gmtToUtc (input) {
    if (!input) return false
    const d = dayjs(input)
    return d.utcOffset() !== dayjs(d).startOf('year').utcOffset()
  }
}

export const ordenarRangoFechas = (rangoFechas, format = FMT.onlyDateDash) => {
  if (!rangoFechas || rangoFechas.length < 1) return rangoFechas
  const fechasDayjs = rangoFechas.map(f => DateService.toDayjs(f, format))
  const ordenadas = fechasDayjs.slice().sort((a, b) => a.valueOf() - b.valueOf())
  return ordenadas.map(f => f.format(format))
}

export default DateService
